import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppRoutes from './routes/Routes';
import { initUserFromCookies } from './redux/auth/actions';
import { createFeatureFlagProvider } from '#helpers/featureFlags';
// setup fake backend
import { configureFakeBackend } from './helpers';

// Main styles
import './assets/scss/app.scss';

// configure fake backend
configureFakeBackend();

function FallbackComponent() {
    return <div>An error has occured. Please contact support@edgemarkets.io </div>;
}

/**
 * Main app component
 */
const App = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.Auth.user);

    // Initialize user state from cookies when app starts
    useEffect(() => {
        dispatch(initUserFromCookies());
    }, [dispatch]);

    return <AppRoutes />;
};

export default createFeatureFlagProvider(App);
